/**
 * Encode a given URI endpoint for easier use as a query parameter.
 * This is used to encode the redirect path for the login page.
 * @param rawUri URI endpoint string.
 * @returns Encoded URI string.
 */
export function encodeRedirectUri(rawUri: string): string{
    return btoa(encodeURIComponent(rawUri));
}

/**
 * Decode a given URI endpoint string that has been encoded with encodeRedirectUri.
 * This is used to get the original redirect path after a successful login.
 * @param encodedUri Encoded URI endpoint string.
 * @returns Clean decoded URI.
 */
export function decodeRedirectUri(encodedUri: string): string{
    return decodeURIComponent(atob(encodedUri));
}